import React from 'react'

/**
 * Shield Icon Component
 * Used in the header to represent security/protection
 */
export const ShieldIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="99" height="99" viewBox="0 0 99 99" fill="none">
    <rect x="21.9219" y="21.917" width="51.9094" height="51.9094" rx="21.3405" fill="white"/>
    <mask id="mask0_5407_144773" maskUnits="userSpaceOnUse" x="0" y="0" width="99" height="99">
      <rect width="98.0511" height="98.0511" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_5407_144773)">
      <path d="M44.7455 63.6235L67.8284 40.5049L62.0066 34.6741L44.7455 51.9619L36.1661 43.3691L30.3443 49.1999L44.7455 63.6235ZM49.0353 90.0156C39.5706 87.6287 31.7572 82.1901 25.5949 73.6996C19.4327 65.2091 16.3516 55.7809 16.3516 45.415L16.3516 20.4551L49.0353 8.17969L81.719 20.4551V45.415C81.719 55.7809 78.6379 65.2091 72.4756 73.6996C66.3134 82.1901 58.4999 87.6287 49.0353 90.0156Z" fill="#5F1AB6"/>
    </g>
  </svg>
)

export const CloseIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({...props}) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={40} height={40} rx={20} fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5 20a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m.833 0a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0m-10.396-2.65a.417.417 0 0 0-.589.589L19.411 20l-2.063 2.063a.417.417 0 0 0 .59.589L20 20.59l2.062 2.062a.417.417 0 0 0 .59-.59L20.589 20l2.063-2.062a.417.417 0 1 0-.59-.59L20 19.412z"
      fill="#7d38d3"
    />
  </svg>
)
